export enum MARKET_TABS {
  OVERVIEW = 'Overview',
  TRADING = 'Trading',
  EARNING = 'Earning',
}

export enum MARKET_SORTERS {
  APY = 'APY',
  TVL = 'TVL',
  VOLUME_24 = 'VOLUME_24',
}
export enum MARKET_FILTERS {
  ALL = 'ALL',
  PERPETUAL = 'PERPETUAL',
  DATED = 'DATED',
}
